// ----------------------------------------------------------------------
// The page a signed-out visitor was opening, kept for after they sign in.
//
// A link into the console opened on a device with no session was sent to
// `/login`, and every way of signing in then went to `/admin`: the page and
// its query were gone. The owner key step is handed to a second device as a
// link and a QR code (`OwnerKeyElsewhere`), so a phone that scanned it
// without a BeastOS session ended on the map, with nothing saying which car
// it had been for. So the address is kept in this tab while the person signs
// in, through every way of doing it (the Tesla, Google and Apple trips leave
// the console and come back to this tab), and taken once by the sign-in that
// finishes.
//
// Only a page under `/admin`, so nothing a crafted link carries can send a
// person off the console after they have signed in.
// ----------------------------------------------------------------------

const KEY = 'beast.signIn.returnTo'

/** Where a sign-in goes when no page was being opened. */
export const SIGN_IN_HOME = '/admin'

/** A path inside the console's own pages, and nothing that leaves them. */
export const signInReturnPathIs = (path: string): boolean =>
  /^\/admin(?:[/?#]|$)/.test(path) && !/[\\\s]/.test(path)

/** Keeps the page a signed-out visitor was opening, if it is the console's. */
export const signInReturnRemember = (
  path: string,
  storage: Storage = sessionStorage,
): void => {
  if (signInReturnPathIs(path)) {
    storage.setItem(KEY, path)
  }
}

/** The page to open once signed in, once: the kept one, or the home page. */
export const signInReturnTake = (storage: Storage = sessionStorage): string => {
  const path = storage.getItem(KEY)
  storage.removeItem(KEY)

  return path && signInReturnPathIs(path) ? path : SIGN_IN_HOME
}
